import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './plugins/element.js'
import '@assets/css/normalize.css'
import '@assets/css/global.scss'
import '@/icons'
import vuescroll from 'vuescroll'// 引入vuescroll
import 'vuescroll/dist/vuescroll.css'// 引入vuescroll样式
import config from '@/static/config'
import subHeader from './views/layout/components/subHeader'
import filter from './views/layout/components/fliter.vue'
import page from './views/layout/components/page.vue'
// eslint-disable-next-line no-unused-vars
import Blob from './excel/Blob'
// eslint-disable-next-line no-unused-vars
import Export2Excel from './excel/Export2Excel'
import i18n from './i18n/i18n'
Vue.prototype.$config = config
Vue.use(vuescroll, {
  ops: {
    vuescroll: {},
    scrollPanel: {},
    rail: {
      keepShow: true
    },
    detectResize: true,
    bar: {
      hoverStyle: true,
      onlyShowBarOnScroll: false, // 是否只有滚动的时候才显示滚动条
      background: '#909399', // 滚动条颜色
      opacity: 0.5, // 滚动条透明度
      'overflow-x': 'hidden'
    }
  }, // 在这里设置全局默认配置
  name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
})
var hrefArray = []
router.beforeEach((to, from, next) => {
  sessionStorage.setItem('hrefArray', hrefArray)
  next()
})

Vue.component('sub-header', subHeader)
Vue.component('filter-box', filter)
Vue.component('page', page)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
